import React from 'react';
import CalendarWidget from './CalendarWidget';

export default function CalendarPage() {
  return (
    <div>
      <div className="page-header">
        <div className="page-header-left">
          <h1>Calendrier</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', marginTop: 2 }}>
            Deadlines AO, entretiens, appels et toutes vos actions à venir
          </p>
        </div>
      </div>
      <CalendarWidget />
    </div>
  );
}
